import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "semantic-ui-react";
import CommonPageHeader from "../../common/ui/page-header/CommonPageHeader";
import OrganizationUsersStats from "./OrganizationUsersStats";
import NoWorkplacePrompt from "./NoWorkplacePrompt";
import { useCompanyWorkplaces } from "../../../hooks/useCompanyWorkplaces";

const HomeDashboard = () => {
  const { t } = useTranslation();
  const { loading: workplacesLoading, hasWorkplaces } = useCompanyWorkplaces();

  return (
    <Container className="py-4 px-3" fluid>
      <CommonPageHeader
        icon={<i className="bi bi-grid-1x2-fill" />}
        title={t("app.homeDashboard.title")}
        description={t("app.homeDashboard.subtitle")}
      />

      <OrganizationUsersStats />

      {!workplacesLoading && !hasWorkplaces ? <NoWorkplacePrompt /> : null}
    </Container>
  );
};

export default HomeDashboard;
